import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const apolloBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Apollo Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Apollo Beach, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_apollo_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Apollo Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Apollo Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the waterfront homes and 
     growing residential community of <strong>Apollo Beach</strong> with expert 
     tree care built for Tampa Bay's coastal environment. Properties here sit 
     right on the water where tidal winds, storm surge, and salt exposure 
     combine to weaken trees faster than in inland areas. When those trees 
     start threatening your dock, seawall, or home, our team handles it safely 
     and professionally.`,

    `We specialize in <strong>hazardous tree removal and waterfront trimming</strong> 
     large limbs overhanging docks and seawalls, storm damaged trees near 
     waterfront structures, palms with root instability in saturated soil, 
     and dense canopy growth that dramatically increases your storm risk. 
     We work carefully on waterfront lots and protect your property throughout.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>Apollo Beach</strong> and the surrounding 
     <strong>South Hillsborough Bay</strong> communities keeping your waterfront 
     property safe and your trees healthy all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Apollo Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_ApolloBeach = () => <LocationPage config={apolloBeachConfig} />;
export default Services_ApolloBeach;
